export const WhenTakenLogo = (props: { gamePage?: boolean }) => {
  const textClasses = props.gamePage ? '2xl:flex' : 'md:flex';

  return (
    <div className="relative top-1 inline-flex flex-row items-center gap-1.5">
      <img src="/assets/images/whentaken.svg" className="size-9" />
      <div className={`hidden text-2xl ${textClasses} 2xl:text-4xl`}>
        <strong className="font-semibold leading-none">When</strong>
        <span className="font-light  leading-none">Taken</span>
      </div>
    </div>
  );
};
